import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'common/store';

interface Aggregate {
  name: string;
  value: number;
}

interface AggregateLabels {
  [key: string]: string;
}

interface AggregatesState {
  aggregates: Aggregate[];
  backupAggregates: Aggregate[];
  aggregateLabels: AggregateLabels;
}

const initialState: AggregatesState = {
  aggregates: [],
  backupAggregates: [],
  aggregateLabels: {},
};

const aggregatesSlice = createSlice({
  name: 'aggregates',
  initialState,
  reducers: {
    setAggregates: (state, action: PayloadAction<Aggregate[]>) => {
      state.aggregates = action.payload;
      state.backupAggregates = action.payload;
    },
    resetAggregates: (state) => {
      state.aggregates = state.backupAggregates;
    },
    setAggregateLabels: (state, action: PayloadAction<AggregateLabels>) => {
      state.aggregateLabels = action.payload;
    },
  },
});

export const selectAggregates = (state: RootState) => state.aggregates.aggregates;
export const selectBackupAggregates = (state: RootState) => state.aggregates.backupAggregates;
export const selectAggregateLabels = (state: RootState) => state.aggregates.aggregateLabels;

export const { setAggregates, resetAggregates, setAggregateLabels } = aggregatesSlice.actions;
export default aggregatesSlice;
